import styles from './FloodSummaryRow.module.css';

/*
    FLOOD SUMMARY ROW (molecule)
        The worst-case reading sits beside the label; where more than one source
        carries a risk, they run inline beneath it, and the "how flood risk is
        assessed" link closes the card.

        No accordion (BBB-454, 20/08): the per-source detail is always on show.
        A single-source breakdown is dropped rather than printed, because it
        would restate the header's own reading in different words. Same label +
        content grid as the other rows in this section, for the same reason: the
        old `space-between` layout left the middle of the card empty, and the
        same bordered chips with a hairline inside, so a source and its risk band
        are separated by something rather than merely adjacent (21/08).
        props:
            title: str
            label: str (e.g. "High flood risk — 25% of field" or "No flood risk")
            sourceLink: { label: str, url: str } | undefined — link to the
                official "how flood risk is assessed" page for the region that
                produced the worst-case reading. Replaces the old "~X% likely"
                annual-chance caption (BBB-456): per-nation methodology differs
                enough that a single percentage risked overstating precision.
            severity: 'high' | 'medium' | 'low' | undefined
            breakdown: [{ source: str, label: str }]
*/

const FloodSummaryRow = (props) => {
  const { title, label, sourceLink, severity, breakdown } = props;
  // Two or more sources: the list tells the farmer something the header cannot.
  // One source: the header already said it.
  const hasBreakdown =
    Boolean(severity) && Array.isArray(breakdown) && breakdown.length > 1;
  const hasRisk = Boolean(severity);

  return (
    <div className={styles.card}>
      <span className={styles.label}>{title}</span>
      <div className={styles.content}>
        <span className={`${styles.chip} ${hasRisk ? styles.chipIn : styles.chipNone}`}>
          {label}
        </span>

        {hasBreakdown ? (
          <p className={styles.breakdown}>
            {breakdown.map((entry, index) => (
              <span key={index} className={styles.srcChip}>
                <span className={styles.srcName}>{entry.source}</span>
                <span className={styles.srcRule} aria-hidden="true" />
                <span className={styles.srcValue}>{entry.label}</span>
              </span>
            ))}
          </p>
        ) : null}

        {sourceLink ? (
          <a
            className={styles.sourceLink}
            href={sourceLink.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {sourceLink.label}
          </a>
        ) : null}
      </div>
    </div>
  );
};

export default FloodSummaryRow;
